// 状态枚举
export const IMPORT_STATUS = {
  VERIFY: 0,
  PENDING: 1,
  COMPLETE: 2,
  ERROR: 99
}

export const IMPORT_STATUS_TEXT = {
  [IMPORT_STATUS.VERIFY]: '校验中',
  [IMPORT_STATUS.PENDING]: '执行中',
  [IMPORT_STATUS.COMPLETE]: '已完成',
  [IMPORT_STATUS.ERROR]: '导入异常'
}

export const IMPORT_STATUS_COLOR = {
  [IMPORT_STATUS.VERIFY]: 'blue',
  [IMPORT_STATUS.PENDING]: 'orange',
  [IMPORT_STATUS.COMPLETE]: '',
  [IMPORT_STATUS.ERROR]: 'red'
}
